import {
	ChangeDetectionStrategy,
	Component,
	input,
	InputSignal,
	OnChanges,
	output,
	OutputEmitterRef,
	SimpleChanges,
} from '@angular/core'
import { TuiPagination } from '@taiga-ui/kit'

@Component({
	selector: 'app-pagination',
	templateUrl: 'pagination.component.html',
	styleUrl: './pagination.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [TuiPagination],
})
export class PaginationComponent implements OnChanges {
	protected readonly math: Math = Math

	public isLoading: InputSignal<boolean> = input<boolean>(false)
	public pageSize: InputSignal<number> = input<number>(30)
	public pageIndex: InputSignal<number> = input<number>(1)
	public total: InputSignal<number> = input<number>(0)
	public pageChange: OutputEmitterRef<number> = output<number>()

	protected page: number = 1

	get paginationIndex(): number {
		return this.page - 1
	}

	get pageCount(): number {
		return this.math.ceil(this.total() / this.pageSize())
	}

	set paginationIndex(value: number) {
		this.page = value + 1
		this.pageChange.emit(this.page)
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['pageIndex']) {
			this.page = this.pageIndex()
		}
	}
}
